import React from 'react'

import Layout from '../components/layout'

const SecondPage = () => (
  <Layout>
    <h2><span role="img" aria-label="Eyes">👀</span> Hello from the second page.</h2>
    <p>Pretty, isn't it?</p>
  </Layout>
)

export default SecondPage
